export default __webpack_public_path__ + "static/home-mr-e00f446287d027418161a264335fe7c2.png";